import { validateDomain } from '../utils/AuthUtils';

const SSODomain =
	(roleType) =>
	(username = '', isLogin = false) => {
		return (dispatch) => {
			return new Promise((resolve, reject) => {
				// this is because the backend api is not ready yet. once the api is ready. fetch it from backend only @arnav
				const domains = ['onemedical.com', 'petsupermarket.com', 'theshadestore.com'];
				const loginStillAllowedByUsernamePWDomains = ['sunnyside.shop'];

				if (!isLogin) {
					domains.push(...loginStillAllowedByUsernamePWDomains);
				}

				if (validateDomain(username.trim(), domains)) {
					reject('Please login with SSO');
				} else {
					resolve(domains);
				}
			});
		};
	};

export const SSODomains = SSODomain('buyer');

export const SSODomainForSupplier = (username = '', isLogin = false) => {
	return (dispatch) => {
		return new Promise((resolve, reject) => {
			// this is because the backend api is not ready yet. once the api is ready. fetch it from backend only @arnav
			const domains = [];
			const loginStillAllowedByUsernamePWDomains = [];

			if (!isLogin) {
				domains.push(...loginStillAllowedByUsernamePWDomains);
			}

			if (validateDomain(username.trim(), domains)) {
				reject('Please login with SSO');
			} else {
				resolve(domains);
			}
		});
	};
};
